import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon, Header } from 'semantic-ui-react';
import {
  BACKGROUND_COLOR,
  WHITE_COLOR,
  SECONDARY_COLOR,
  PRIMARY_COLOR,
  PRIMARY_COLOR_HIGHLIGHT,
} from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Panel
 * parameters
 * @param content object: PropTypes.node.isRequired
 * @param title string: PropTypes.string.isRequired
 * @param icon string: PropTypes.string
 * @param wrapped bool: PropTypes.bool = by true the panel will be wrapper in a container
 *   with a min height = browserUtil.getOuterHeight(), used by a container with only a panel
 * @param closePanel function
 * @param string mode
 *
 * Notice: if the container has more as one panel, we should use the component panels
 */
export default class Panel extends Component {
  constructor(props) {
    super(props);
    this.toggleHoverIconClose = this.toggleHoverIconClose.bind(this);
    this.state = {
      hoverIcon: false,
    };
  }

  /**
   * Toggle hover icon close
   */
  toggleHoverIconClose() {
    const { hoverIcon } = this.state;
    this.setState({ hoverIcon: !hoverIcon });
  }

  render() {
    const { content, title, icon, wrapped, mode, closePanel } = this.props;
    const { hoverIcon } = this.state;
    const styleIconClose = hoverIcon
      ? { color: PRIMARY_COLOR_HIGHLIGHT }
      : { color: PRIMARY_COLOR };

    const styleContainer = { backgroundColor: WHITE_COLOR };
    const styleContainerWrapper = {
      width: '100%',
      backgroundColor: BACKGROUND_COLOR,
      minHeight: `${window.outerHeight}px`,
      padding: '1.5rem 1.5rem 1.5rem 0.5rem',
    };
    const styleBarHeader = { backgroundColor: PRIMARY_COLOR };
    const styleHeader = {
      backgroundColor: SECONDARY_COLOR,
      color: PRIMARY_COLOR,
    };
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleIconClose.color = hoverIcon
        ? modeColors.PANEL_ICON_HEADER_HIGHLIGHT_COLOR
        : modeColors.PANEL_ICON_HEADER_COLOR;
      styleContainer.backgroundColor = modeColors.PANEL_BACKGROUND_COLOR;
      styleContainer.color = modeColors.PANEL_COLOR;
      styleContainerWrapper.backgroundColor = modeColors.BACKGROUND_COLOR;
      styleBarHeader.backgroundColor = modeColors.PANEL_HEADER_BAR_COLOR;
      styleHeader.backgroundColor = modeColors.PANEL_HEADER_BACKGROUND_COLOR;
      styleHeader.color = modeColors.PANEL_HEADER_COLOR;
    }
    return (
      <div style={wrapped ? styleContainerWrapper : {}}>
        <Grid style={styleContainer} className="panel">
          <div className="bar" style={styleBarHeader} />
          <Grid.Row className="title" style={styleHeader}>
            <Grid.Column computer={14} tablet={14} mobile={14}>
              <Header as="h5" className="header" style={styleHeader}>
                <Icon name={icon} />
                {title}
              </Header>
            </Grid.Column>
            {closePanel !== null && (
              <Grid.Column width={2} textAlign="right">
                <Icon
                  name="close"
                  style={styleIconClose}
                  onClick={closePanel}
                  className="icon-close-panel"
                  onMouseEnter={this.toggleHoverIconClose}
                  onMouseLeave={this.toggleHoverIconClose}
                />
              </Grid.Column>
            )}
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className="content">{content}</div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

Panel.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  wrapped: PropTypes.bool,
  closePanel: PropTypes.func,
  mode: PropTypes.string,
};

Panel.defaultProps = {
  icon: null,
  wrapped: false,
  closePanel: null,
  mode: null,
};
